import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
Vue.use(_Swipe);
Vue.use(_SwipeItem);
var height = 18;
/**
 * @prop { Object } content
 * mainImg: 图片url
 * mainTitle: 主标题
 * rightTopTitle: 右上角标题
 * leftBottomTitle: 左下角icon
*/
export default {
  name: 'circle-bubble',
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    this.initSwiper();
  },
  watch: {
    content: {
      handler: function handler(newVal) {
        this.list = newVal.rightTopTitle && newVal.rightTopTitle.split('↓').filter(function (item) {
          return item !== '';
        });
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      list: [],
      swiperRefHeight: 0
    };
  },
  methods: {
    initSwiper: function initSwiper() {},
    handleItemClick: function handleItemClick() {
      this.$emit('item-click', this.content);
    }
  }
};